import { render, staticRenderFns } from "./Plain.vue?vue&type=template&id=19f71bae&scoped=true"
import script from "./Plain.vue?vue&type=script&lang=ts"
export * from "./Plain.vue?vue&type=script&lang=ts"
import style0 from "./Plain.vue?vue&type=style&index=0&id=19f71bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f71bae",
  null
  
)

export default component.exports